import React, { Fragment } from "react";

const Input = (props) => {
  const {
    className = "form-control",
    id = "exampleFormControlFirstName",
    type = "text",
    name,
    placeholder,
    value,
    onChange,
    autoComplete = "off",
    readOnly = false,
    disabled = false,
    label,
    requiredLabel = false,
    error,
    maxLength,
    style,
    minDateRange,
    maxDateRange,
    isNumber = false,
    ...restProps
  } = props;
  const inputRef = React.useRef(null);

  const handleClick = () => {
    if (inputRef && inputRef.current) inputRef.current.focus();
  };
  const onKeyDown = (e) => {
    if (isNumber) {
      [
        "e",
        "E",
        "+",
        "-",
        "=",
        "!",
        "@",
        "#",
        "$",
        "%",
        "^",
        "&",
        "*",
        "(",
        ")",
        "_",
        "?",
        ">",
        "<",
        ",",
        ";",
        "/",
        "'",
        "{",
        "}",
        "[",
        "]",
        ".",
        ":",
      ].includes(e.key) && e.preventDefault();
    }
  };
  return (
    <Fragment>
      <label>
        {label}
        {requiredLabel && <span className="required-field"></span>}
      </label>
      <input
        {...restProps}
        ref={inputRef}
        className={className}
        id={id}
        type={type}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        readOnly={readOnly}
        autoComplete={autoComplete}
        maxLength={maxLength}
        style={style}
        min={minDateRange}
        max={maxDateRange}
        onKeyDown={onKeyDown}
      />
      {error && <span style={{ color: "red" }}>{error}</span>}
    </Fragment>
  );
};
export default Input;
